import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	priorityAltText: {
		id: 'calendar.calendar-unscheduled-panel.calendar-unscheduled-panel-card-list.calendar-unscheduled-panel-card.calendar-card-priority.priorityAltText',
		defaultMessage: '{priority} priority',
		description: 'Text describing the image shat shows the priority of an issue',
	},
});
